import React from 'react'
import '../../styles/5-Portfolio/Portfolio.css'

const ProjectItem = ({ updateProject, project, isActive }) => {
  return (
    <li className={ isActive ? `project-item active` : `project-item` } onClick={() => updateProject(project)}>
      <span className='project-item__number'>{project.id}</span>
      <h4 className='project-item__name'>{project.name}</h4>
    </li>
  )
}

export default ProjectItem